import React from "react";
import { Carousel } from "react-bootstrap";
import "./Banner.css";
import slide1 from "../../../../src/images/slide-1.jpg";
import slide2 from "../../../../src/images/slide-2.jpg";
import slide3 from "../../../../src/images/slide-3.jpg";
import slide4 from "../../../../src/images/slide-4.jpg";

const Banner = () => {
  return (
    <section className="home-banner">
      <div className=" mt-5 pt-5 d-flex justify-content-center align-items-center banner-container">
        <Carousel className="main-carousel mx-auto">
          <Carousel.Item className="carousel-item" interval={2000}>
            <img
              className="d-block w-100 rounded"
              src={slide1}
              alt="First slide"
            />
            <Carousel.Caption>
              <h1>TECH GIANT</h1>
              <p>The largest PC parts Warehouse in the country.</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item className="carousel-item" interval={2000}>
            <img className="d-block w-100" src={slide2} alt="Second slide" />
            <Carousel.Caption>
              {" "}
              <h1>TECH GIANT</h1>
              <p>The largest PC parts Warehouse in the country.</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item className="carousel-item" interval={2000}>
            <img className="d-block w-100" src={slide3} alt="Second slide" />
            <Carousel.Caption>
              {" "}
              <h1>TECH GIANT</h1>
              <p>The largest PC parts Warehouse in the country.</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item className="carousel-item" interval={2000}>
            <img className="d-block w-100" src={slide4} alt="Second slide" />
            <Carousel.Caption>
              {" "}
              <h1>TECH GIANT</h1>
              <p>The largest PC parts Warehouse in the country.</p>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </div>
    </section>
  );
};

export default Banner;
